import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { TreeItem, SimpleTreeView, treeItemClasses } from '@mui/x-tree-view';
import { styled } from '@mui/material/styles';
import { pluralize } from '@mcn-platform/models';
import { Typography, Stack, Box, } from '@mui/material';
import { borderColorLight } from '../tss/colors';
const StyledTreeItemRoot = styled(TreeItem)(({ theme }) => ({
    color: theme.palette.subNav.text.primary,
    marginBottom: 1,
    // 1st level
    [`& .${treeItemClasses.content}`]: {
        position: 'relative',
        minHeight: '45px',
        color: theme.portal.global.inverseFont.color,
        borderRadius: theme.spacing(2),
        padding: theme.spacing(1),
        marginTop: theme.spacing(2),
        fontWeight: theme.typography.fontWeightBold,
        background: theme.portal?.site?.sidebar?.selectedItem?.backgroundColor,
        '&:hover': {
            backgroundColor: theme.portal?.site?.sidebar?.selectedItem?.backgroundColor,
        },
        '&.Mui-focused, &.Mui-selected, &.Mui-selected.Mui-focused': {
            backgroundColor: theme.portal?.site?.sidebar?.selectedItem?.backgroundColor,
        },
        [`& .${treeItemClasses.label}`]: {
            fontWeight: 'inherit',
            color: 'inherit',
        },
    },
    // 2nd level
    [`& .${treeItemClasses.groupTransition}`]: {
        marginLeft: 0,
        [`& .${treeItemClasses.content}`]: {
            // width: 'calc(100% - 24px)', // fix smooth collapse transition
            color: 'subNav.text.primary',
            paddingLeft: theme.spacing(2.5),
            [`& .${treeItemClasses.label}`]: {
                color: 'inherit',
                paddingLeft: theme.spacing(1.625),
            },
        },
    },
}));
const LeftNavBar = ({ sections, selectedItem, setSelectedItem, }) => {
    const [expanded, setExpanded] = React.useState([]);
    const renderTree = (section) => (_jsx(StyledTreeItemRoot, { itemId: section.type, label: (_jsx(Stack, { direction: "row", justifyContent: "space-between", children: _jsx(Stack, { justifyContent: "center", children: _jsx(Typography, { variant: "body1", children: pluralize(section.label) }) }) })), sx: {
            [`& .${treeItemClasses.content}`]: {
                backgroundColor: 'transparent',
                borderRadius: '0 !important',
                borderBottom: `1px solid ${borderColorLight}`,
                '&:hover': {
                    backgroundColor: (t) => (t.portal?.site?.sidebar?.selectedItem?.backgroundColor),
                },
            },
            ...(selectedItem?.type === section.type && {
                [`& .${treeItemClasses.content}`]: {
                    backgroundColor: (t) => (t.portal?.site?.sidebar?.selectedItem?.backgroundColor),
                    '&.Mui-focused, &.Mui-selected, &.Mui-selected.Mui-focused': {
                        backgroundColor: (t) => (t.portal?.site?.sidebar?.selectedItem?.backgroundColor),
                    },
                },
            }),
        }, onClick: () => setSelectedItem(section) }, section.type));
    const handleToggle = (e, nodeIds) => {
        setExpanded(nodeIds);
    };
    return (_jsx(Box, { sx: {
            width: '100%',
            height: '100%',
            backgroundImage: (t) => (`linear-gradient(0deg, ${t.palette.subNav.bottomColor}, ${t.palette.subNav.topColor})`),
        }, children: sections?.length > 0
            && (_jsx(SimpleTreeView, { "aria-label": "course sections tree view", expandedItems: expanded, sx: {
                    minHeight: '100%',
                    color: 'subNav.text.primary',
                    padding: '16px',
                }, onExpandedItemsChange: handleToggle, children: sections.map((section) => renderTree(section)) })) }));
};
export default LeftNavBar;
//# sourceMappingURL=LeftNavBar.js.map